/* eslint-disable max-len */
const operatingRulesContent = {
  meta: {
    company: 'CÔNG TY TNHH TM DV BOOKESE VIỆT NAM',
    title: 'QUY CHẾ HOẠT ĐỘNG NỀN TẢNG THƯƠNG MẠI ĐIỆN TỬ BOOKESE',
    intro: 'Quy chế này công bố cách Bookese vận hành nền tảng, quy trình đặt dịch vụ và trách nhiệm của Bookese, nhà cung cấp và khách hàng. Quy chế áp dụng chung cho dịch vụ lưu trú, vé máy bay và vé tham quan, trải nghiệm trên bookese.com.',
  },
  sections: [
    {
      id: 'muc-I',
      title: 'I. Thông tin chung và phạm vi áp dụng',
      items: [
        {
          id: 'muc-I-1',
          title: '1. Chủ quản nền tảng: CÔNG TY TNHH TM DV BOOKESE VIỆT NAM (sau đây gọi là “Bookese”); mã số doanh nghiệp/mã số thuế 0319613120; trụ sở: Tầng 12 (1206), CitiLight Tower, 45 Võ Thị Sáu, Phường Tân Định, Thành phố Hồ Chí Minh, Việt Nam; website: bookese.com; email hỗ trợ: info@bookese.com; tổng đài: 078 222 1131. Người đại diện theo pháp luật: ông Tất Gia Hữu.',
          content: [],
        },
        {
          id: 'muc-I-2',
          title: '2. Nền tảng cho phép khách hàng tìm kiếm, so sánh, gửi yêu cầu đặt và thanh toán dịch vụ do nhà cung cấp hợp pháp đăng tải hoặc được Bookese phân phối theo thỏa thuận. Bookese cung cấp công cụ giao dịch, xác nhận và hỗ trợ; chủ thể trực tiếp thực hiện dịch vụ, bên thu tiền và bên xuất hóa đơn được thể hiện tại trang dịch vụ, bước thanh toán hoặc chứng từ giao dịch. Khi Bookese trực tiếp là bên bán, Bookese chịu nghĩa vụ của bên cung cấp dịch vụ tương ứng.',
          content: [],
        },
        {
          id: 'muc-I-3',
          title: '3. Quy chế áp dụng cho khách truy cập, khách hàng, đối tác lưu trú, nhà cung cấp vé máy bay, nhà cung cấp vé tham quan/trải nghiệm và bên liên quan khi dùng bookese.com. Điều kiện riêng của sản phẩm được công bố trước khi đặt và là một phần của giao dịch. Nếu điều kiện riêng trái quy định bắt buộc của pháp luật hoặc hạn chế quyền người tiêu dùng trái luật thì áp dụng quy định pháp luật.',
          content: [],
        },
        {
          id: 'muc-I-4',
          title: '4. Các bên giao dịch trên cơ sở tự nguyện, trung thực, minh bạch. Dịch vụ thuộc ngành nghề có điều kiện chỉ được đăng bán khi bên cung cấp đáp ứng điều kiện tương ứng. Bookese có quyền từ chối hoặc tạm ẩn sản phẩm chưa đủ hồ sơ.',
          content: [],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'muc-II',
      title: 'II. Giải thích từ ngữ và nguyên tắc hiển thị',
      items: [
        {
          id: 'muc-II-1',
          title: '1. “Khách hàng” là cá nhân, tổ chức tìm kiếm hoặc đặt dịch vụ; “Nhà cung cấp” là cơ sở lưu trú, hãng hàng không/đơn vị phân phối vé hợp pháp, đơn vị tổ chức hoặc cung cấp vé tham quan, trải nghiệm; “Đặt chỗ” là yêu cầu giao dịch được ghi nhận trên hệ thống; “Xác nhận” là thông điệp xác nhận dịch vụ đã được chấp nhận, có mã đặt chỗ hoặc mã vé tương ứng.',
          content: [],
        },
        {
          id: 'muc-II-2',
          title: '2. Thông tin sản phẩm cần thể hiện tên và nhận diện nhà cung cấp; đặc điểm, địa điểm, thời gian sử dụng; giá cuối cùng, thuế, phí bắt buộc và khoản tùy chọn; điều kiện đối tượng sử dụng; quy định đổi, hủy, hoàn tiền; phương thức thanh toán, xác nhận và nhận dịch vụ. Các khoản phát sinh tại cơ sở hoặc điểm sử dụng phải được nêu rõ nếu đã biết.',
          content: [],
        },
        {
          id: 'muc-II-3',
          title: '3. Thứ tự hiển thị kết quả có thể dựa trên mức độ phù hợp với tìm kiếm, giá, tình trạng còn chỗ, đánh giá, chất lượng thông tin, vị trí và chương trình thương mại. Nội dung được tài trợ hoặc ưu tiên có trả phí, nếu có, được gắn dấu hiệu phân biệt. Khách hàng có thể sử dụng bộ lọc, sắp xếp có sẵn để thay đổi kết quả.',
          content: [],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'muc-III',
      title: 'III. Đăng ký tài khoản và tham gia của nhà cung cấp',
      items: [
        {
          id: 'muc-III-1',
          title: '1. Khách hàng có thể đăng ký bằng thông tin yêu cầu trên website hoặc đăng nhập theo phương thức nền tảng hỗ trợ. Khách phải cung cấp thông tin liên hệ chính xác, bảo mật mật khẩu và mã xác thực, không dùng danh tính người khác hoặc tạo giao dịch giả. Người thực hiện đặt chỗ phải đủ 18 tuổi hoặc có năng lực, thẩm quyền hợp pháp; thông tin của người đi cùng chỉ được cung cấp khi đã có căn cứ phù hợp để cung cấp.',
          content: [],
        },
        {
          id: 'muc-III-2',
          title: '2. Đối tác lưu trú gửi hồ sơ qua ps@bookese.com. Bookese xác minh tư cách pháp lý, mã số thuế, thông tin người đại diện, quyền cung cấp dịch vụ và giấy phép/chứng nhận khi pháp luật yêu cầu; ký thỏa thuận và cấp quyền quản lý sau khi xét duyệt. Nhà cung cấp vé máy bay và vé tham quan, trải nghiệm thực hiện quy trình xác minh tương ứng trước khi được hiển thị.',
          content: [],
        },
        {
          id: 'muc-III-3',
          title: '3. Nhà cung cấp cập nhật tồn chỗ, giá, điều kiện dịch vụ, ảnh và mô tả trung thực; thông báo kịp thời thay đổi; thực hiện đặt chỗ đã xác nhận; cung cấp chứng từ, hóa đơn theo vai trò của mình; hợp tác xử lý khiếu nại, hoàn tiền và yêu cầu của cơ quan có thẩm quyền. Bookese có thể yêu cầu tài liệu bổ sung, kiểm tra mẫu, tạm ngừng hiển thị hoặc chấm dứt hợp tác khi có căn cứ vi phạm.',
          content: [],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'muc-IV',
      title: 'IV. Quy trình giao dịch chung',
      items: [
        {
          id: 'muc-IV-1',
          title: '1. Khách hàng chọn sản phẩm, ngày, số lượng và phương án giá; kiểm tra thông tin người sử dụng, điều kiện dịch vụ và tổng số tiền tại màn hình rà soát trước khi gửi yêu cầu đặt. Khách có thể sửa thông tin tại bước này. Giá và khả dụng được kiểm tra lại khi xác nhận; trường hợp thay đổi, Bookese thông báo để khách chấp nhận giá mới hoặc dừng giao dịch.',
          content: [],
        },
        {
          id: 'muc-IV-2',
          title: '2. Sau khi khách chọn phương thức thanh toán và xác nhận đặt, hệ thống ghi nhận yêu cầu và thông báo trạng thái. Việc nhận yêu cầu hoặc trừ tiền tạm thời chưa tự động là xác nhận dịch vụ. Giao dịch hoàn tất khi Bookese/nhà cung cấp gửi xác nhận có mã đặt chỗ, vé điện tử hoặc voucher. Nếu không thể xác nhận sau khi đã thu tiền, Bookese phối hợp hoàn lại khoản đã thu theo phương thức và thời hạn thông báo cho khách.',
          content: [],
        },
        {
          id: 'muc-IV-3',
          title: '3. Khách xem trạng thái trong tài khoản hoặc email xác nhận; sử dụng mã đặt chỗ/vé và giấy tờ cần thiết tại nơi cung cấp dịch vụ. Mọi yêu cầu thay đổi, hủy và hoàn tiền thực hiện qua chức năng trên nền tảng hoặc kênh hỗ trợ, theo điều kiện đã công bố tại thời điểm đặt và quyền bắt buộc theo pháp luật.',
          content: [],
        },
        {
          id: 'muc-IV-4',
          title: '4. Thời hạn thanh toán của từng yêu cầu được hiển thị trong quá trình đặt. Yêu cầu chưa thanh toán hoặc chưa được xác nhận có thể hết hiệu lực khi quá thời hạn; nếu đã thu tiền nhưng không xác nhận được dịch vụ, Bookese phối hợp hoàn tiền. Chứng từ dịch vụ được gửi điện tử qua email, tài khoản hoặc kênh đã công bố. Việc giao chứng từ giấy, nếu có, phải được nêu riêng tại thông tin sản phẩm.',
          content: [],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'muc-V',
      title: 'V. Quy trình theo từng dịch vụ',
      items: [
        {
          id: 'muc-V-1',
          title: '1. Lưu trú',
          content: [
            'Khách tìm cơ sở lưu trú theo địa điểm, ngày nhận/trả phòng, số khách/phòng; chọn loại phòng, gói giá, dịch vụ kèm theo; rà soát giờ nhận/trả phòng, chính sách trẻ em, phụ thu, đặt cọc, hủy/không hoàn hủy; nhập thông tin khách và thanh toán. Xác nhận gửi qua email hoặc tài khoản. Cơ sở lưu trú trực tiếp cung cấp phòng đúng hạng và điều kiện đã xác nhận. Khi hết phòng, sai mô tả đáng kể hoặc không thể nhận khách, Bookese phối hợp đề xuất phương án tương đương hoặc hoàn tiền và xử lý thiệt hại theo lỗi, thỏa thuận và pháp luật.',
          ],
        },
        {
          id: 'muc-V-2',
          title: '2. Vé máy bay',
          content: [
            'Khách chọn hành trình, chuyến bay, hạng vé, hành lý và dịch vụ bổ sung; nhập đúng họ tên theo giấy tờ đi lại, ngày sinh và thông tin hãng yêu cầu; rà soát lịch bay, sân bay, điều kiện giá vé, phí, hành lý, đổi/hủy/hoàn, giấy tờ, thị thực và thời hạn thanh toán. Vé chỉ được coi là phát hành khi có số vé điện tử/mã đặt chỗ được hãng hoặc hệ thống phân phối xác nhận. Hãng hàng không trực tiếp vận chuyển và quyết định lịch bay, điều kiện chuyên chở; Bookese hỗ trợ đặt, phát hành và chuyển yêu cầu đổi/hủy theo vai trò thể hiện trong giao dịch. Thay đổi do hãng, lỡ chuyến, vé chưa sử dụng hoặc chỉ sử dụng một chặng được xử lý theo điều kiện vé, quy định của hãng và pháp luật áp dụng; phí dịch vụ của Bookese, nếu có, phải hiển thị riêng trước thanh toán.',
          ],
        },
        {
          id: 'muc-V-3',
          title: '3. Vé tham quan và trải nghiệm',
          content: [
            'Khách chọn điểm tham quan/hoạt động, ngày giờ, số lượng và nhóm tuổi; rà soát địa điểm tập trung, thời lượng, nội dung bao gồm/không bao gồm, giới hạn sức khỏe/độ tuổi, thời tiết, yêu cầu đặt trước, thời hạn sử dụng và chính sách đổi/hủy. Xác nhận có thể là mã QR, voucher hoặc hướng dẫn nhận vé; điều kiện quét mã, xuất trình giấy tờ và số lần sử dụng được ghi trên vé. Đơn vị tổ chức trực tiếp bảo đảm chất lượng và an toàn hoạt động. Nếu đóng cửa, hủy suất hoặc thay đổi trọng yếu, Bookese phối hợp thông báo, bố trí lại hoặc hoàn tiền theo điều kiện công bố và pháp luật.',
          ],
        },
        {
          id: 'muc-V-4',
          title: '4. Yêu cầu đặc biệt và sử dụng dịch vụ',
          content: [
            'Khách gửi yêu cầu hỗ trợ đặc biệt qua kênh được công bố; Bookese chuyển tới nhà cung cấp và thông báo kết quả. Yêu cầu chỉ có hiệu lực khi được nhà cung cấp xác nhận. Khách sử dụng đúng thời gian, địa điểm, số lượng người và điều kiện trên xác nhận, xuất trình giấy tờ hoặc mã điện tử khi cần. Trường hợp đến muộn, không đến hoặc chỉ sử dụng một phần, quyền sử dụng phần còn lại và khoản hoàn được xử lý theo điều kiện đã công bố cho sản phẩm và pháp luật.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'muc-VI',
      title: 'VI. Giá, thanh toán, hóa đơn và khuyến mại',
      items: [
        {
          id: 'muc-VI-1',
          title: '1. Giá hiển thị bằng đồng Việt Nam, trừ khi giao diện cho phép đồng tiền khác; màn hình cuối cùng thể hiện tổng phải trả và tách rõ thuế, phí dịch vụ, phụ phí, khoản tùy chọn nếu có. Giá có thể thay đổi theo thời điểm và tồn chỗ trước khi đơn được xác nhận; đơn đã xác nhận được xử lý theo giá ghi trên xác nhận, trừ lỗi hiển thị rõ ràng được thông báo và khách đồng ý sửa hoặc hủy.',
          content: [],
        },
        {
          id: 'muc-VI-2',
          title: '2. Nền tảng hỗ trợ các phương thức đang hiển thị tại bước thanh toán, gồm thẻ nội địa, thẻ quốc tế, mã QR MoMo và các phương thức khác được công bố tại bước thanh toán. Giao dịch qua tổ chức thanh toán hợp pháp. Khách không chuyển tiền vào tài khoản hoặc đường dẫn ngoài thông tin thanh toán chính thức. Bookese thông báo trạng thái thanh toán, đối soát khoản thu và phối hợp xử lý thanh toán trùng hoặc thất bại.',
          content: [],
        },
        {
          id: 'muc-VI-3',
          title: '3. Chủ thể xuất hóa đơn và cách yêu cầu hóa đơn được chỉ rõ trong quá trình đặt hoặc xác nhận giao dịch. Mã giảm giá, xu, voucher và quà tặng chỉ áp dụng theo thể lệ công bố: đối tượng, thời gian, giới hạn sử dụng, điều kiện kết hợp, thứ tự khấu trừ và ảnh hưởng khi hoàn/hủy. Xu, điểm và voucher không mặc nhiên là tiền mặt hoặc được hoàn quy đổi; điều kiện cụ thể phải công bố trước khi tham gia.',
          content: [],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'muc-VII',
      title: 'VII. Đổi, hủy, hoàn tiền và sự cố',
      items: [
        {
          id: 'muc-VII-1',
          title: '1. Điều kiện đổi/hủy/hoàn của từng gói lưu trú, hạng vé bay hoặc vé trải nghiệm được hiển thị trước khi khách xác nhận. Bookese không áp dụng một mức phí chung cho mọi sản phẩm. Yêu cầu thay đổi phụ thuộc tình trạng dịch vụ, thời điểm yêu cầu, điều kiện của nhà cung cấp và phí đã công bố. Bookese gửi kết quả, khoản hoàn dự kiến và trạng thái xử lý qua kênh giao dịch.',
          content: [],
        },
        {
          id: 'muc-VII-2',
          title: '2. Khi nhà cung cấp không thể thực hiện dịch vụ, dịch vụ không đúng nội dung đã công bố hoặc phát sinh sự cố thuộc trách nhiệm của bên cung cấp/Bookese, các bên ưu tiên khắc phục, đổi dịch vụ tương đương nếu khách đồng ý, hoặc hoàn lại phần tương ứng và giải quyết thiệt hại theo pháp luật. Quy định “không hoàn hủy” không loại trừ quyền của khách khi có vi phạm nghĩa vụ hoặc quyền bắt buộc theo pháp luật.',
          content: [],
        },
        {
          id: 'muc-VII-3',
          title: '3. Tiền hoàn được trả về phương thức thanh toán ban đầu khi khả thi; trường hợp khác chỉ thực hiện sau khi thống nhất với khách và xác minh an toàn. Thời gian ghi có thực tế phụ thuộc ngân hàng, cổng thanh toán và nhà cung cấp; Bookese thông báo mốc xử lý cụ thể khi tiếp nhận yêu cầu. Không dùng voucher thay tiền hoàn nếu khách không đồng ý, trừ trường hợp pháp luật hoặc điều kiện giao dịch hợp lệ cho phép.',
          content: [],
        },
        {
          id: 'muc-VII-4',
          title: '4. Khi hệ thống gián đoạn, sai giá, thanh toán trùng, xác nhận chậm hoặc dấu hiệu gian lận, Bookese bảo lưu log, thông báo tình trạng và cung cấp kênh hỗ trợ; không tự ý hủy một đơn đã xác nhận mà không có căn cứ theo điều kiện giao dịch hoặc pháp luật.',
          content: [],
        },
        {
          id: 'muc-VII-5',
          title: '5. Khi nhà cung cấp thay đổi lịch, hủy chuyến, hủy suất, đóng cửa hoặc phát sinh sự kiện ngoài khả năng kiểm soát hợp lý của các bên, Bookese tiếp nhận thông tin, thông báo khách và phối hợp đề xuất đổi lịch, dịch vụ thay thế hoặc hoàn tiền. Khách được thông báo điều kiện, chênh lệch giá và khoản hoàn trước khi chấp nhận phương án. Trách nhiệm và bồi thường được xác định theo nguyên nhân, thỏa thuận hợp lệ và pháp luật; quyền đối với phần dịch vụ không được cung cấp vẫn được giải quyết.',
          content: [],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'muc-VIII',
      title: 'VIII. Quyền và trách nhiệm của các bên',
      items: [
        {
          id: 'muc-VIII-1',
          title: '1. Bookese',
          content: [
            'Bookese vận hành nền tảng ổn định, công khai quy chế và thông tin liên hệ; xác thực và quản lý thông tin nhà cung cấp; kiểm tra, rà soát, gỡ bỏ nội dung vi phạm; bảo đảm quy trình rà soát đơn, xác nhận và lưu trữ thông tin giao dịch; bảo vệ dữ liệu, tiếp nhận khiếu nại, phối hợp bồi hoàn và cung cấp thông tin cho cơ quan có thẩm quyền theo pháp luật. Bookese chịu trách nhiệm đối với lỗi của mình, cam kết do mình đưa ra và trách nhiệm của chủ quản nền tảng; không có điều khoản nào trong Quy chế loại trừ trách nhiệm bắt buộc hoặc quyền yêu cầu bồi thường hợp pháp của người tiêu dùng.',
          ],
        },
        {
          id: 'muc-VIII-2',
          title: '2. Nhà cung cấp',
          content: [
            'Nhà cung cấp được đăng dịch vụ, quản lý giá/tồn chỗ và nhận thanh toán theo hợp đồng; phải có quyền kinh doanh hợp pháp, công bố chính xác điều kiện, thực hiện đúng dịch vụ đã xác nhận, bảo đảm an toàn/chất lượng, xuất hóa đơn theo nghĩa vụ, bảo mật dữ liệu nhận được, giải quyết khiếu nại và bồi thường thiệt hại do lỗi của mình. Nhà cung cấp không được chuyển khách ra ngoài nền tảng để né nghĩa vụ hoặc thu khoản phí chưa công bố.',
          ],
        },
        {
          id: 'muc-VIII-3',
          title: '3. Khách hàng',
          content: [
            'Khách có quyền được cung cấp thông tin rõ ràng, chọn và rà soát dịch vụ, nhận xác nhận/chứng từ, yêu cầu hỗ trợ, khiếu nại, hoàn tiền và bồi thường theo quy định. Khách có trách nhiệm cung cấp thông tin chính xác, thanh toán đúng hạn, tuân thủ quy định hợp pháp của cơ sở lưu trú/hãng/điểm tham quan đã được thông báo, bảo vệ tài khoản và sử dụng đánh giá trung thực. Khách không tạo giao dịch giả, lợi dụng khuyến mại, phát tán mã độc hoặc xâm phạm quyền của người khác.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'muc-IX',
      title: 'IX. Kiểm duyệt, xử lý vi phạm và đánh giá',
      items: [
        {
          id: 'muc-IX-1',
          title: '1. Bookese rà soát hồ sơ nhà cung cấp trước khi cấp quyền, kiểm tra nội dung bằng công cụ và nhân sự, tiếp nhận báo cáo từ người dùng/chủ thể quyền, yêu cầu giải trình và chứng cứ; có thể sửa yêu cầu hiển thị, ẩn sản phẩm, tạm khóa tài khoản, chấm dứt hợp tác và chuyển cơ quan chức năng tùy mức độ. Nội dung cấm gồm dịch vụ trái pháp luật, gian lận giá hoặc tồn chỗ, thông tin sai lệch, xâm phạm sở hữu trí tuệ, quảng cáo sai, đánh giá giả, xâm phạm dữ liệu và quyền người tiêu dùng.',
          content: [],
        },
        {
          id: 'muc-IX-2',
          title: '2. Khi hạn chế hoặc chấm dứt tài khoản nhà cung cấp, Bookese thông báo lý do và cách khiếu nại theo thời hạn pháp luật áp dụng, trừ trường hợp cần xử lý ngay theo yêu cầu cơ quan có thẩm quyền hoặc ngăn rủi ro cấp bách. Các đơn đã xác nhận vẫn được bảo vệ và xử lý riêng. Bookese có thể cung cấp dữ liệu hợp đồng đã giao kết cho nhà cung cấp trong thời hạn luật định.',
          content: [],
        },
        {
          id: 'muc-IX-3',
          title: '3. Khách chỉ đánh giá giao dịch đã sử dụng hoặc đủ điều kiện đánh giá. Bookese hiển thị đánh giá và cơ chế xác minh, có quyền gỡ đánh giá xúc phạm, tiết lộ dữ liệu, quảng cáo hoặc gian lận; không xóa đánh giá hợp lệ chỉ vì nội dung bất lợi cho nhà cung cấp.',
          content: [],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'muc-X',
      title: 'X. Bảo vệ dữ liệu và an toàn giao dịch',
      items: [
        {
          id: 'muc-X-1',
          title: '1. Bookese thu thập, xử lý và chia sẻ thông tin tài khoản, đặt chỗ, thanh toán ở mức cần thiết để cung cấp dịch vụ, phòng gian lận, chăm sóc khách hàng và thực hiện nghĩa vụ pháp lý. Quyền của chủ thể dữ liệu, thời hạn lưu trữ, bên nhận dữ liệu, chuyển dữ liệu ra nước ngoài và kênh yêu cầu được quy định chi tiết trong “Chính sách bảo vệ dữ liệu cá nhân” công bố trên bookese.com; chính sách này là tài liệu liên quan của Quy chế. Chính sách được công bố và cập nhật để bao phủ dữ liệu khách lưu trú, hành khách và người tham gia trải nghiệm được thu thập thực tế.',
          content: [],
        },
        {
          id: 'muc-X-2',
          title: '2. Thanh toán được xử lý qua đối tác thanh toán; Bookese không yêu cầu khách cung cấp mật khẩu, OTP hoặc số thẻ đầy đủ qua điện thoại, email, chat. Khách báo ngay giao dịch nghi vấn hoặc mất quyền truy cập qua kênh hỗ trợ. Bookese áp dụng phân quyền, bảo mật đường truyền, giám sát và xử lý sự cố theo quy định.',
          content: [],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'muc-XI',
      title: 'XI. Tiếp nhận khiếu nại và giải quyết tranh chấp',
      items: [
        {
          id: 'muc-XI-1',
          title: '1. Khách hàng, nhà cung cấp và bên liên quan gửi mã đặt chỗ, nội dung, chứng cứ qua tổng đài 078 222 1131 (hoạt động 24/7), email info@bookese.com, mục Liên hệ hỗ trợ trên website hoặc địa chỉ trụ sở. Bookese xác nhận tiếp nhận trong 24 giờ làm việc; trường hợp đơn giản phản hồi kết quả trong 03 ngày làm việc; trường hợp cần xác minh nhiều bên dự kiến trong 07 ngày làm việc và cập nhật tiến độ nếu kéo dài. Mốc này là cam kết xử lý nội bộ; quyền khiếu nại và thời hạn bắt buộc theo luật được ưu tiên áp dụng.',
          content: [],
        },
        {
          id: 'muc-XI-2',
          title: '2. Bookese thu thập chứng cứ, đối chiếu điều kiện đặt và làm việc với nhà cung cấp/đối tác thanh toán; thông báo kết quả, căn cứ, biện pháp khắc phục và đường phản hồi. Bookese là đầu mối tiếp nhận khi giao dịch có nhiều hơn hai bên; hỗ trợ cung cấp thông tin nhà cung cấp trong phạm vi pháp luật cho phép. Hồ sơ được lưu tối thiểu ba năm hoặc dài hơn nếu pháp luật yêu cầu.',
          content: [],
        },
        {
          id: 'muc-XI-3',
          title: '3. Các bên ưu tiên thương lượng. Nếu không đạt kết quả, khách có quyền yêu cầu cơ quan bảo vệ người tiêu dùng, hòa giải, trọng tài khi có thỏa thuận hợp lệ hoặc tòa án có thẩm quyền. Không nội dung nào buộc khách từ bỏ quyền khiếu nại, khởi kiện hoặc bồi thường theo pháp luật.',
          content: [],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'muc-XII',
      title: 'XII. Hiệu lực và sửa đổi',
      items: [
        {
          id: 'muc-XII-1',
          title: '1. Quy chế có hiệu lực kể từ ngày công bố trên bookese.com. Bookese công khai phiên bản và ngày áp dụng, thông báo trước thay đổi ảnh hưởng đáng kể đến quyền và nghĩa vụ của thành viên bằng phương thức phù hợp. Giao dịch đã xác nhận được xử lý theo điều kiện tại thời điểm đặt, trừ khi thay đổi có lợi cho khách hoặc pháp luật yêu cầu áp dụng khác.',
          content: [],
        },
        {
          id: 'muc-XII-2',
          title: '2. Bookese xác minh nhà cung cấp và điều kiện kinh doanh đối với từng nhóm dịch vụ; hiển thị thông tin sản phẩm, giá và điều kiện đổi, hủy trước khi nhận giao dịch; thực hiện nghĩa vụ bảo vệ dữ liệu cá nhân và thủ tục thông báo, đăng ký hoặc điều chỉnh thông tin với cơ quan quản lý khi pháp luật yêu cầu.',
          content: [],
        },
        {
          id: 'muc-XII-3',
          title: '3. Quy chế được giải thích và thực hiện theo pháp luật Việt Nam. Nếu một điều khoản vô hiệu, các điều khoản còn lại vẫn có hiệu lực trong phạm vi pháp luật cho phép.',
          content: [],
        },
      ],
      paragraphs: [],
    },
  ],
};

export default operatingRulesContent;
